import { paths } from '../../app/routes'

/**
 * Where the keypad's digits go back to. The artboard keeps this in `s.prev`; here it rides
 * on the navigation state, so a reload lands on a screen that still makes sense rather
 * than one that silently submits to the wrong place.
 *
 * Kept out of the screen module so building the route does not import a component.
 */
export interface ManualTarget {
  kind: 'pallet' | 'serial' | 'assignPallet'
  /** Required for 'serial' — the pallet the serial is being typed into. */
  palletCode?: string
}

export function resolveManualTarget(state: unknown): ManualTarget {
  const candidate = state as ManualTarget | null

  if (candidate?.kind === 'assignPallet') {
    return candidate
  }

  if (candidate?.kind === 'serial' && typeof candidate.palletCode === 'string') {
    return candidate
  }

  return { kind: 'pallet' }
}

/** Built here so callers cannot disagree about the shape of the navigation state. */
export function manualRouteFor(target: ManualTarget): { to: string; state: ManualTarget } {
  return { to: paths.manual, state: target }
}
